import components from './components'
import loginPage from './login_page'
import register from './register'
import registerWaiting from './register_waiting'
import phoneRegister from './phone/register'
import email from './email/index.js'
import resetPassword from './reset_password'
import hr_bind from './hr_bind'
export default {
  components,
  loginPage,
  register,
  email,
  phoneRegister,
  registerWaiting,
  resetPassword,
  hr_bind,
}
